import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuItemsDirective } from './context-menu-items.directive';

@NgModule({
  declarations: [ContextMenuItemsDirective],
  imports: [
    CommonModule
  ],
  exports: [ContextMenuItemsDirective]
})
export class ContextMenuItemsModule { }
